module.exports = __webpack_public_path__ + "assets/img/BEWIN.8fb0c0b3.png";